(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vics-immersive-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vics-art-slideshow')){
customElements.define('vics-art-slideshow',class extends HTMLElement{
 connectedCallback(){
  this.slides=[...this.querySelectorAll('.vics-scene-slide')];this.dots=[...this.querySelectorAll('.vics-scene-dot')];
  if(!this.slides.length)return;
  this.ready=false;this.request=0;this.index=0;this.hovered=false;this.dragged=false;this.visible=true;this.abort=new AbortController();
  const opts={signal:this.abort.signal};this.motion=matchMedia('(prefers-reduced-motion: reduce)');
  this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.show(i),opts));
  this.addEventListener('mouseenter',()=>{this.hovered=matchMedia('(hover: hover)').matches;this.schedule()},opts);
  this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule()},opts);
  this.addEventListener('focusin',()=>this.schedule(),opts);
  this.addEventListener('focusout',()=>setTimeout(()=>this.schedule(),0),opts);
  document.addEventListener('visibilitychange',()=>this.schedule(),opts);
  this.motion.addEventListener('change',()=>this.schedule(),opts);
  this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1))}},opts);
  this.addEventListener('pointerdown',e=>{this.startX=e.clientX;this.startY=e.clientY;this.dragged=false},opts);
  this.addEventListener('pointerup',e=>{const dx=e.clientX-this.startX,dy=e.clientY-this.startY;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)){this.dragged=true;this.show(this.index+(dx<0?1:-1))}},opts);
  this.addEventListener('click',e=>{if(this.dragged){e.preventDefault();this.dragged=false}},opts);
  this.addEventListener('shopify:block:select',e=>{const index=this.slides.findIndex(s=>s.contains(e.target)||s===e.target);if(index>=0)this.show(index)},opts);
  this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule()});this.observer.observe(this);
  const first=this.slides[0].querySelector('img');
  const ready=()=>{if(!this.isConnected)return;this.ready=true;this.loadSlide(1);this.schedule()};
  if(first.complete&&first.naturalWidth)ready();else{first.addEventListener('load',ready,{once:true,signal:this.abort.signal});first.addEventListener('error',ready,{once:true,signal:this.abort.signal})}
 }
 loadSlide(index){
  const slide=this.slides[(index+this.slides.length)%this.slides.length];
  if(!slide)return Promise.resolve();
  slide.querySelectorAll('source[data-srcset]').forEach(source=>{source.srcset=source.dataset.srcset;source.removeAttribute('data-srcset')});
  const image=slide.querySelector('img');
  if(!image)return Promise.resolve();
  image.loading='eager';
  if(image.dataset.srcset){image.srcset=image.dataset.srcset;image.removeAttribute('data-srcset')}
  if(image.dataset.src){image.src=image.dataset.src;image.removeAttribute('data-src')}
  return image.decode().catch(()=>{});
 }
 async show(index){
  const request=++this.request;
  index=(index+this.slides.length)%this.slides.length;
  await this.loadSlide(index);
  if(request!==this.request||!this.isConnected)return;
  this.index=(index+this.slides.length)%this.slides.length;
  this.slides.forEach((slide,i)=>{const active=i===this.index;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));slide.tabIndex=active?0:-1;if(active)slide.querySelector('img').loading='eager'});
  this.dots.forEach((dot,i)=>{dot.classList.toggle('is-active',i===this.index);dot.setAttribute('aria-current',String(i===this.index))});
  this.loadSlide(this.index+1);
  this.schedule();
 }
 schedule(){
  clearTimeout(this.timer);
  if(!this.ready||this.slides.length<2||this.motion.matches||document.hidden||!this.visible||this.hovered||this.querySelector(':focus-visible'))return;
  this.timer=setTimeout(()=>this.show(this.index+1),Number(this.dataset.interval)||3000);
 }
 disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.observer?.disconnect()}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vics-more-to-love"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vics-series-carousel')) {
  customElements.define('vics-series-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.vics-series__track');
      this.prev = this.querySelector('[data-series-prev]');
      this.next = this.querySelector('[data-series-next]');
      this.more = this.querySelector('template[data-series-more]');
      if (!this.track || !this.prev || !this.next) return;
      this.controller = new AbortController();
      this.frame = 0;
      const options = { signal: this.controller.signal };
      this.update = () => {
        this.prev.disabled = this.track.scrollLeft < 2;
        this.next.disabled = !this.hasMore &&
          this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      };
      const move = (direction) => this.track.scrollBy({
        left: direction * (this.track.clientWidth + parseFloat(getComputedStyle(this.track).gap)),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
      this.prev.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => {
        this.appendNearEnd();
        move(1);
      }, options);
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.appendNearEnd();
          this.update();
        });
      }, { ...options, passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    get hasMore() {
      return Boolean(this.more?.content.firstElementChild);
    }
    appendNearEnd() {
      const remaining = this.track.scrollWidth - this.track.clientWidth - this.track.scrollLeft;
      if (!this.hasMore || remaining > this.track.clientWidth + 2) return;
      const batch = document.createDocumentFragment();
      for (let index = 0; index < 8 && this.hasMore; index++) {
        batch.append(this.more.content.firstElementChild);
      }
      this.track.append(batch);
      if (!this.hasMore) this.more.remove();
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vics-why-vicsart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vics-benefits')) {
    customElements.define('vics-benefits', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.vics-benefits__track');
        this.items = Array.from(this.querySelectorAll('.vics-benefits__item'));
        this.dots = Array.from(this.querySelectorAll('.vics-benefits__dot'));
        this.mobile = window.matchMedia('(max-width: 749px)');
        const update = () => {
          if (!this.items.length || !this.mobile.matches) return;
          const trackRect = this.track.getBoundingClientRect();
          const left = trackRect.left + parseFloat(getComputedStyle(this.track).paddingLeft);
          let current = 0;
          let distance = Infinity;
          this.items.forEach((item, index) => {
            const delta = Math.abs(item.getBoundingClientRect().left - left);
            if (delta < distance) { current = index; distance = delta; }
          });
          this.dots.forEach((dot, index) => {
            if (index === current) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          this.current = current;
        };
        const move = (index) => {
          if (!this.mobile.matches || !this.items[index]) return;
          const offset = this.items[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left - parseFloat(getComputedStyle(this.track).paddingLeft);
          this.track.scrollBy({ left: offset, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => move(index), { signal }));
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; update(); });
        }, { signal, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (!this.mobile.matches || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let index = this.current || 0;
          if (event.key === 'ArrowLeft') index -= 1;
          if (event.key === 'ArrowRight') index += 1;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this.items.length - 1;
          move(Math.max(0, Math.min(this.items.length - 1, index)));
        }, { signal });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
